module.exports = __webpack_public_path__ + "img/content-yellow.ded6a3ef.png";